import React, { lazy, Suspense } from 'react';
import { createBrowserRouter } from 'react-router-dom';
import Loader from '../Components/common/Loader';

import HomeLayout from '../Layouts/HomeLayout';
import ShopLayout from '../Layouts/ShopLayout';

const Home01 = lazy(() => import('../Pages/Homes/Home01'));
const About = lazy(() => import('../Pages/About'));
const Blog01 = lazy(() => import('../Pages/Blogs/Blog01'));
const BlogDetails = lazy(() => import('../Pages/Blogs/BlogDetails'));
const ContactPage = lazy(() => import('../Pages/ContactPage'));
const FAQ = lazy(() => import('../Pages/FAQ'));
const TeamPage = lazy(() => import('../Pages/TeamPage'));
const Projects01 = lazy(() => import('../Pages/Projects/Projects01'));
const Projects02 = lazy(() => import('../Pages/Projects/Projects02'));
const ProjectDetails = lazy(() => import('../Pages/Projects/ProjectDetails'));
const Apartment = lazy(() => import('../Pages/Apartment/Apartment'));
const Construction = lazy(() => import('../Pages/Construction/Construction'));
const ImportExport = lazy(() => import('../Pages/ImportExport/ImportExport'));
const GasLPG = lazy(() => import('../Pages/GasLPG/GasLPG'));
const FactoryOverview = lazy(() => import('../Pages/FactoryOverview/CrushingPlant'));
const ErrorPage = lazy(() => import('../Pages/ErrorPage/ErrorPage'));

const withSuspense = (Component) => (
  <Suspense fallback={<Loader />}>
    <Component />
  </Suspense>
);

export const routes = createBrowserRouter([
  {
    path: '/',
    element: <HomeLayout />,
    children: [
      { path: '/', element: withSuspense(Home01) },
      { path: '/project', element: withSuspense(Projects01) },
      { path: '/project-2', element: withSuspense(Projects02) },
      { path: '/project-details/:id', element: withSuspense(ProjectDetails) },
      { path: '/about', element: withSuspense(About) },
      { path: '/team', element: withSuspense(TeamPage) },
      { path: '/faq', element: withSuspense(FAQ) },
      { path: '/blog-1', element: withSuspense(Blog01) },
      { path: '/blog-details/:id', element: withSuspense(BlogDetails) },
      { path: '/contact', element: withSuspense(ContactPage) },
      { path: '*', element: withSuspense(ErrorPage) },
    ],
  },
  {
    path: '/',
    element: <ShopLayout />,
    children: [
      { path: '/construction', element: withSuspense(Construction) },
      { path: '/ImportExport', element: withSuspense(ImportExport) },
      { path: '/gaslpg', element: withSuspense(GasLPG) },
      { path: '/factoryOverview', element: withSuspense(FactoryOverview) },
      { path: '/apartment', element: withSuspense(Apartment) },
      { path: '*', element: withSuspense(ErrorPage) },
    ],
  },
]);
